import { css } from '@emotion/react';
import { useTranslation, Trans } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, TextLink } from '@frontend/design-system';

export const TermsAndConditionsBody = () => {
  const { t } = useTranslation('payments');

  return (
    <>
      <Text>
        {t(
          'To get started with Weave Payments ("Payments Service"), please acknowledge and agree to the following and then create a new Stripe account:'
        )}
      </Text>
      <ul
        css={css`
          > li {
            margin-bottom: ${theme.spacing(1)};
          }
        `}
      >
        <Text as='li'>
          {t(
            'Weave’s Card Not Present payment processing service is provided at the standard rate of 3.15% + $0.30 per transaction. For offices using Weave’s Terminal service, Card Present and Card Not Present rates are disclosed in the Weave Payments Quote, which supersede the above mentioned standard rate.'
          )}
        </Text>
        <Text as='li'>
          {t(
            "There is a minimum for ACH transactions of $250. Anything less than $250 must be a credit/debit card transaction. [or] Transactions for less than $250 will not be approved for an ACH transaction. There may be an additional Stripe charge of 1% + $1.75 fee for every ACH transaction. (i.e. $250+ $2.50 + $1.75) Stripe may charge this fee to verify that a bank account is open, that funds are available, or in other instances where a payment may fail and at Stripe's discretion."
          )}
        </Text>

        <Text as='li'>
          <Trans t={t}>
            The Payments Service is provided subject to Weave&apos;s Terms of Service located at{' '}
            <TextLink href='https://getweave.com/legal/terms' target='_blank'>
              https://getweave.com/legal/terms/
            </TextLink>
            , including the Weave Payment Processing Service Terms located at{' '}
            <TextLink href='https://getweave.com/legal/payments' target='_blank'>
              https://getweave.com/legal/payments/
            </TextLink>{' '}
            (collectively, &quot;Terms&quot;). By accessing or otherwise using the Payments Service, you expressly
            acknowledge and agree to the Terms.
          </Trans>
        </Text>
        <Text as='li'>
          <Trans t={t}>
            The Payments Service is provided by Weave through its third-party processor, Stripe, Inc.
            (&quot;Stripe&quot;) and is subject to the{' '}
            <TextLink href='https://stripe.com/legal/connect-account' target='_blank'>
              Stripe Connected Account Agreement
            </TextLink>
            , which includes the{' '}
            <TextLink href='https://stripe.com/legal' target='_blank'>
              Stripe Terms of Service
            </TextLink>{' '}
            (collectively, the &quot;Stripe Services Agreement&quot;). By agreeing to these Terms or continuing to use
            the Payments Service, you agree to the Stripe Services Agreement.
          </Trans>
        </Text>
      </ul>
    </>
  );
};
